// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".job-card-chip[data-v-f4057bec]{border-style:solid;border-width:1px;padding:2px 12px;vertical-align:bottom;width:-moz-fit-content;width:fit-content}.job-card-chip__text[data-v-f4057bec]{font-size:15px;letter-spacing:-.45px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
